// extracted by mini-css-extract-plugin
export default {"wrapper":"background_wrapper__0DIA0","image":"background_image__ddnKw","background":"background_background__Q6oc-","content":"background_content__4YVBn"};